function shouldDiscountProduct(productId, fullPricedCollection) {
  for (const element of fullPricedCollection) {
    if (element["id"] == productId) { return true; }
  }
  
  return false;
}

function getDiscountFromCookie() {
    const getCookieValue = (name) => (
      document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || ''
    )

    var discountCode = getCookieValue("discount_code");
    if (discountCode == null || discountCode == 0){
    	return 0;
    }
  
   if(discountCode.startsWith('FRIEND-')){
       discountCode ='FRIEND-';   
    }

    var percentToReturn = 0;

    jQuery.ajax({
        url: "https://nira-shopify-bucket.s3.amazonaws.com/discount_codes.json",
        dataType: "json",
        success: function(data) {
          if (data[discountCode] > 0) {
            percentToReturn = data[discountCode];
           
          }
        },
        async: false
    });

    return percentToReturn;
} 

function getDiscountCodeFromCookies() {
    const getCookieValue = (name) => (
      document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || ''
    )

    var discountCode = getCookieValue("discount_code");

   return discountCode;
}

function getStrikeThroughPriceFor(currentVariantPrice, countryCode ,show_original_strike_through) {
    var percentOff = getDiscountFromCookie();
    return getStrikeThroughPriceFromPriceAndDiscount(currentVariantPrice, percentOff, 2,countryCode,show_original_strike_through);
}

function getStrikeThroughPriceWithNoDecimalFor(currentVariantPrice,countryCode, productId) {
    var percentOff = getDiscountFromCookie();
    return getStrikeThroughPriceFromPriceAndDiscount(currentVariantPrice, percentOff, 0,countryCode);
}

function getStrikeThroughPriceFromPriceAndDiscount(currentVariantPrice, percentOff, decimalPlaces,countryCode,show_original_strike_through) {
    if (percentOff == null || percentOff == 0) { return null; }
    var price = currentVariantPrice * ((100 - percentOff) / 100);
    return getStrikeThroughForOriginalAndNewPrice(currentVariantPrice, price, decimalPlaces,countryCode,show_original_strike_through);
}

      const currencyData = {
  'AT': { symbol: '€', format: '€{price}' }, // Austria
  'BE': { symbol: '€', format: '€{price}' }, // Belgium
  'BG': { symbol: 'лв', format: '{price} лв' }, // Bulgaria
  'CY': { symbol: '€', format: '€{price}' }, // Cyprus
  'CZ': { symbol: 'Kč', format: '{price} Kč' }, // Czech Republic
  'DE': { symbol: '€', format: '€{price}' }, // Germany
  'DK': { symbol: 'kr', format: '{price} kr' }, // Denmark
  'EE': { symbol: '€', format: '€{price}' }, // Estonia
  'ES': { symbol: '€', format: '€{price}' }, // Spain
  'FI': { symbol: '€', format: '€{price}' }, // Finland
  'FR': { symbol: '€', format: '€{price}' }, // France
  'GB': { symbol: '£', format: '£{price}' }, // United Kingdom
  'GR': { symbol: '€', format: '€{price}' }, // Greece
  'HU': { symbol: 'Ft', format: '{price} Ft' }, // Hungary
  'IE': { symbol: '€', format: '€{price}' }, // Ireland
  'IT': { symbol: '€', format: '€{price}' }, // Italy
  'LT': { symbol: '€', format: '€{price}' }, // Lithuania
  'LU': { symbol: '€', format: '€{price}' }, // Luxembourg
  'LV': { symbol: '€', format: '€{price}' }, // Latvia
  'MT': { symbol: '€', format: '€{price}' }, // Malta
  'NL': { symbol: '€', format: '€{price}' }, // Netherlands
  'PL': { symbol: 'zł', format: '{price} zł' }, // Poland
  'PT': { symbol: '€', format: '€{price}' }, // Portugal
  'RO': { symbol: 'lei', format: '{price} lei' }, // Romania
  'SK': { symbol: '€', format: '€{price}' }, // Slovakia
  'SI': { symbol: '€', format: '€{price}' }, // Slovenia
  'SE': { symbol: 'kr', format: '{price} kr' } // Sweden
};


function getStrikeThroughForOriginalAndNewPrice(originalPrice, newPrice, decimalPlaces, countryCode,show_original_strike_through) {
    // Convert prices to dollars with the specified decimal places
    var priceAsDollars = (newPrice / 100).toFixed(decimalPlaces);
    var originalPriceAsDollars = Math.floor(originalPrice / 100);
    
    // Calculate the multiplier factor
    var igPriceMultiplier = (1 - ((originalPrice - newPrice) / originalPrice)).toFixed(3);
    
    // Add commas to the price (if needed)
    priceAsDollars = numberWithCommas(priceAsDollars);
    originalPriceAsDollars = numberWithCommas(originalPriceAsDollars);

    // Use default values for currency if country code is not found in the dictionary
    const currency = currencyData[countryCode] || { symbol: '$', format: '${price}' };
    
    if (show_original_strike_through === 'false') {
     
      return `<span class='custom-discounted-price' data-price data-price-multiplier='${igPriceMultiplier}'> ${currency.symbol}${priceAsDollars}</span>`
    }
    // Format the output using the currency symbol and format
    return `<s class='original_price_strike'>${currency.symbol}${originalPriceAsDollars}</s> <span class='custom-discounted-price' data-price data-price-multiplier='${igPriceMultiplier}'> ${currency.symbol}${priceAsDollars}</span>`;
}

// Function to add commas to numbers
function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function getDiscountedPriceFor(currentVariantPrice, productId) {
    var percentOff = getDiscountFromCookie();

    if (percentOff == null || percentOff == 0){
    	return null;
    }

    var price = currentVariantPrice * ((100 - percentOff) / 100);
    return (price / 100).toFixed(2);
}

document.addEventListener("smart-cart-hidden", function(element) {
  console.log("show smart hidden");
  document.body.classList.remove("slideout-right--open");
});

function waitForjQueryLazy(trigger) {
  var interval = setInterval(function () {
    if (window.jQuery !== undefined) {
      clearInterval(interval);
      trigger(window.jQuery);
    }
  }, 50);
  setTimeout(function () {
    clearInterval(interval);
  }, 15000);
}



waitForjQueryLazy(function () {
  $(function() {
    $('.lazy').Lazy();
  });
});

document.addEventListener('DOMContentLoaded', function () {
  var subDirectorys = window.location.pathname;
  var directories = subDirectorys.includes('subscription')
  console.log('DIR',subDirectorys)
  if (!directories) {
    document.querySelectorAll('.subscribe-page-only').forEach(section => {
      section.style = "display: none";
    });
  }
  
  if (directories) {
    document.querySelectorAll('.not-on-subscribe-page').forEach(section => {
      section.style = "display: none";
    });
  }
  // var urlParams = new URLSearchParams(window.location.search);
  // if (urlParams.get("variant") !== "subscribe") {
  //   document.querySelectorAll('.subscribe-page-only').forEach(section => {
  //     section.style = "display: none";
  //   });
  // }
  
  // if (urlParams.get("variant") === "subscribe") {
  //   document.querySelectorAll('.not-on-subscribe-page').forEach(section => {
  //     section.style = "display: none";
  //   });
  // }
});

function waitForjQueryCustom(trigger) {
  var interval = setInterval(function () {
    if (window.jQuery !== undefined) {
      clearInterval(interval);
      trigger(window.jQuery);
    }
  }, 50);
  setTimeout(function () {
    clearInterval(interval);
  }, 15000);
}

waitForjQueryCustom(function () {
  $(document).ready(function () {
    $(".price-test-add-to-cart").click(function () {

        console.log("gtag");
      
        gtag("event", "add_to_cart", {
          url: window.location.href
        });
    
        var value = $(".price-item--regular").html().replace("$", "");
        var floatValue = parseFloat(value);
    
        fbq("track", "AddToCart", {
          value: floatValue,
        });
      });
  });
});

